import React, { memo } from 'react';
export const Footer = memo(function Footer() {
  return <footer className="py-12 px-4 bg-gray-950 border-t border-gray-800" data-id="element-58">
      <div className="max-w-4xl mx-auto text-center" data-id="element-59">
        <div className="mb-6" data-id="element-60">
          <h4 className="text-white font-black text-xl tracking-wider mb-1" data-id="element-61">
            ConstruyeProgreso™
          </h4>
          <p className="text-blue-500 font-bold text-sm italic" data-id="element-62">
            Aprendé. Construí. Progresá.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-2 md:gap-4 text-gray-400 text-sm mb-8" data-id="element-63">
          <a href="https://www.construyeprogreso.com" className="hover:text-blue-400 transition-colors" data-id="element-64">
            🌐 www.construyeprogreso.com
          </a>
          <span className="hidden md:inline text-gray-700" data-id="element-65">|</span>
          <a href="mailto:construyeprogresoo@gmail.com" className="hover:text-blue-400 transition-colors" data-id="element-66">
            📧 construyeprogresoo@gmail.com
          </a>
        </div>

        <p className="text-gray-600 text-xs" data-id="element-67">
          © {new Date().getFullYear()} ConstruyeProgreso™ — Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
});